// extracted by mini-css-extract-plugin
export default {"container":"FreeTrialBadge_container__B3HF-","text":"FreeTrialBadge_text__IwSiF"};